import { userManager } from './oidc';
import { setCurrentEnvironment } from '../config/environmentConfig';

const authService = {
  async getAccessToken() {
    const user = await userManager.getUser();
    if (!user || user.expired) {
      throw new Error('Usuário não autenticado');
    }
    return user.access_token;
  },

  clearToken() {
    // Intencionalmente vazio — oidc-client-ts gerencia o ciclo de vida do token
  },

  switchEnvironment(env) {
    setCurrentEnvironment(env);
  },
};

export default authService;
